<script lang="ts">
  import { doLogin } from "../lib/stores";

  let email = "";
  let password = "";
  let error = "";
  let submitting = false;

  async function submit() {
    if (!email || !password) { error = "Enter your email and password."; return; }
    error = "";
    submitting = true;
    try {
      await doLogin(email, password);
    } catch (e) {
      error = e instanceof Error ? e.message : "Sign-in failed.";
    } finally {
      submitting = false;
    }
  }

  function onKeydown(e: KeyboardEvent) {
    if (e.key === "Enter") submit();
  }
</script>

<div class="modal-overlay">
  <div class="modal" role="dialog" aria-modal="true" aria-labelledby="loginTitle">
    <div class="modal-head">
      <div class="modal-title" id="loginTitle">Sign in</div>
    </div>
    <div class="modal-body">
      <div class="modal-hint" style="margin-bottom:2px;">This board is shared — sign in with the account your admin created for you.</div>
      <label>Email
        <input type="text" bind:value={email} autocomplete="username" />
      </label>
      <label>Password
        <input type="password" bind:value={password} autocomplete="current-password" on:keydown={onKeydown} />
      </label>
      <div class="modal-hint" style="color:var(--status-critical);">{error}</div>
    </div>
    <div class="modal-foot">
      <div class="spacer"></div>
      <button class="btn primary" type="button" disabled={submitting} on:click={submit}>
        {submitting ? "Signing in…" : "Sign in"}
      </button>
    </div>
  </div>
</div>
